import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsTable {
    export const ID = 'cms-table';

    export interface IComponentData extends NICmsContentComponent.IData {
        wrap: boolean;
        rows: IRow[];
    }

    interface IRow {
        isHeader?: boolean;
        fields?: IField[];
        backgroundColor?: string;
        font?: string;
        color?: string;
    }

    interface IField {
        text?: string;
        color?: string;
        colSpan?: number;
        rowSpan?: number;
    }
}

@ICmsComponent<CmsTableComponent>({
    id: NCmsTable.ID,
    name: 'Table',
    fields: [
        {
            key: 'wrap',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Wrap',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            key: 'rows',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Rows',
            itemName: 'Row',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IToggleField>{
                    key: 'isHeader',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Mark as header',
                    default: false,
                    labels: { true: 'Yes', false: 'No' }
                },
                {
                    key: 'backgroundColor',
                    type: NICmsContentField.EFieldType.colorPicker,
                    title: 'Background color'
                },
                {
                    key: 'font',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Font',
                    options: TextStyleOptions
                },
                {
                    key: 'color',
                    type: NICmsContentField.EFieldType.colorPicker,
                    title: 'Text color'
                },
                <NICmsContentField.IRepeaterField>{
                    key: 'fields',
                    type: NICmsContentField.EFieldType.repeater,
                    itemNameField: 'text',
                    fields: [
                        {
                            title: 'Text',
                            key: 'text',
                            default: 'Field text',
                            type: NICmsContentField.EFieldType.textarea
                        },
                        {
                            key: 'color',
                            type: NICmsContentField.EFieldType.colorPicker,
                            title: 'Text color',
                            description: 'If not set, the text color will be the same as the row color'
                        },
                        <NICmsContentField.INumberField>{
                            title: 'Column span',
                            key: 'colSpan',
                            default: 1,
                            min: 1,
                            type: NICmsContentField.EFieldType.number
                        },
                        <NICmsContentField.INumberField>{
                            title: 'Row span',
                            key: 'rowSpan',
                            default: 1,
                            min: 1,
                            type: NICmsContentField.EFieldType.number
                        }
                    ],
                    defaultSize: 3
                }
            ]
        }
    ]
})
@Component({
    standalone: true,
    imports: [NgClass, ICmsClientModule],
    selector: 'cms-table',
    templateUrl: './cms-table.html',
    styleUrl: './cms-table.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsTableComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsTable.IComponentData;
}
